import { render } from "./index.vue?vue&type=template&id=b50ef614&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b50ef614&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b50ef614"
/* hot reload */
if (module.hot) {
  script.__hmrId = "b50ef614"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b50ef614', script)) {
    api.reload('b50ef614', script)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=b50ef614&scoped=true", () => {
    api.rerender('b50ef614', render)
  })

}

script.__file = "src/components/Breadcrumb/index.vue"

export default script